<div [@routeAnimations]="getRouteAnimationData()">
  <router-outlet />
</div>
